import { ChangeEvent, FC, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import Checkbox from "../../components/Checkbox";
import Button from "../../components/Button";
import { login } from "../../services/auth.service";
import { getAccessToken, setAccessToken, setRefreshToken } from "../../utils/tokenStorage";
import Logo from "./../../assets/images/logo.png";

const SignIn = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isRemember, setIsRemember] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>("");
  const [commonError, setCommonError] = useState<string>("");
  const navigate = useNavigate();
  useEffect(() => {
    if (email?.length > 3 && password) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [email, password]);

  useEffect(() => {
    let token = getAccessToken();
    if (token) {
      navigate("/");
    }
  }, []);

  function validatePassword(password: string) {
    if (password.length < 8 || password.indexOf(" ") !== -1) {
      return "Password must be at least 8 characters long and can't contain spaces.";
    }

    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[?.,!_\-~$%+=@#^&]).+$/;

    if (!regex.test(password)) {
      return "Password must contain at least one uppercase letter, one lowercase letter, one symbol, and one number.";
    }
    return true;
  }

  function validateEmail(email: string) {
    if (email.length > 80) {
      return "Email address must be at most 80 characters long.";
    }

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!regex.test(email)) {
      return "Please enter a valid email address.";
    }

    return true;
  }

  const onChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setEmailError("");
    setCommonError("");
  };

  const onChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);

    setPasswordError("");
    setCommonError("");
  };

  const onLogin = async () => {
    try {
      const loginError = validateEmail(email);
      if (typeof loginError === "string") {
        setEmailError(loginError);
        return;
      }
      const passwordError = validatePassword(password);
      if (typeof passwordError === "string") {
        setPasswordError(passwordError);
        return;
      }
      setIsLoading(true);
      const { data } = await login(email, password);
      if (data?.success) {
        setAccessToken(data?.accessToken);
        setRefreshToken(data?.refreshToken);
        navigate("/statistics");
      }
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);

      if (!error?.success) {
        setCommonError(error.message);
      }
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.infoBody}>
        <div className={styles.logo}>
          <img src={Logo} alt="logo of project" />
        </div>
        <h1 className={styles.signIn__title}>LDX</h1>
      </div>
      <div className={styles.signInForm}>
        <Input
          value={email}
          onChange={onChangeEmail}
          label={"Email"}
          placeholder={"example@gmail.com"}
          wrapperStyles={styles.input}
          error={emailError}
        />
        <Input
          value={password}
          onChange={onChangePassword}
          label={"Password"}
          placeholder={"Password"}
          type={"password"}
          wrapperStyles={styles.input}
          error={passwordError}
          isShow
        />
        <div className={styles.checkboxContainer}>
          <Checkbox isChecked={isRemember} setIsChecked={setIsRemember} />
          <span>Remember me</span>
        </div>
        {commonError && <p className={styles.commonError}>{commonError}</p>}
        <div style={{ height: "25px" }} />
        <Button
          disabled={isDisabled}
          loading={isLoading}
          onClick={onLogin}
          title={"Login"}
          styleType={isDisabled ? "disabled" : "filled"}
        />
      </div>
    </div>
  );
};

export default SignIn;
